// extracted by mini-css-extract-plugin
module.exports = {"error-state-small":"error-state-small__error-state-small___2vsf-","subtitle":"error-state-small__subtitle___2279K"};